(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfcm-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.bfcmBound) return;
      root.dataset.bfcmBound = 'true';

      // Copy code
      root.querySelectorAll('[data-bfcm-copy]').forEach((button) => {
        const label = button.textContent.trim();
        button.addEventListener('click', async () => {
          const status = root.querySelector('.bfcm__copy-status');
          try {
            await navigator.clipboard.writeText(button.dataset.bfcmCopy);
            button.textContent = 'Copied';
            if (status) status.textContent = 'Code copied. Paste it in the discount field at checkout.';
          } catch (error) {
            if (status) status.textContent = 'Select the code above and copy it manually.';
          }
          setTimeout(() => {
            button.textContent = label;
          }, 2000);
        });
      });

      // Variant picker: keep both prices in step with the selected variant. Sale variants get no
      // "with code" price, because the code doesn't apply to sale items.
      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-bfcm-variant]');
        if (!select) return;
        const option = select.selectedOptions[0];
        const card = select.closest('.bfcm-card');
        if (!option || !card) return;
        const prices = card.querySelector('.bfcm-card__prices');
        const onSale = option.dataset.sale === 'true';
        card.querySelector('[data-bfcm-regular-label]').textContent = onSale
          ? prices.dataset.saleLabel
          : prices.dataset.regularLabel;
        card.querySelector('[data-bfcm-regular]').textContent = option.dataset.regular;
        card.querySelector('[data-bfcm-final]').textContent = onSale ? '' : option.dataset.final;
        card.querySelector('[data-bfcm-final-line]').hidden = onSale;
        card.querySelector('[data-bfcm-sale-note]').hidden = !onSale;
      });

      // Add to cart over AJAX; without JS the form posts to /cart/add as normal
      root.addEventListener('submit', async (event) => {
        const form = event.target.closest('[data-bfcm-form]');
        if (!form) return;
        event.preventDefault();

        const button = form.querySelector('[data-bfcm-submit]');
        const status = form.querySelector('[data-bfcm-status]');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';

        try {
          const addResponse = await fetch(`${root.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const added = await addResponse.json();
          if (!addResponse.ok || added.status) {
            throw new Error(added.description || added.message || root.dataset.errorText);
          }

          const cartResponse = await fetch(`${root.dataset.cartUrl}.js`, {
            headers: { Accept: 'application/json' },
          });
          const cart = await cartResponse.json();

          // Same event name as the theme's CartAddEvent ('cart:update'): the cart icon sets its count
          // from itemCount, the cart items re-render, and the drawer opens if auto-open is on.
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'bfcm-2026',
                data: {
                  source: 'bfcm-2026',
                  itemCount: cart.item_count,
                  productId: String(added.product_id),
                  variantId: String(added.variant_id),
                },
              },
            })
          );

          status.textContent = root.dataset.addedText;
        } catch (error) {
          status.textContent = error.message || root.dataset.errorText;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    };

    const run = () => document.querySelectorAll('[data-bfcm]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
